import React, { useState } from 'react';
import { Button, Typography, Box, CircularProgress } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTheme } from '@mui/material/styles';
import { Auth } from 'aws-amplify';
import LogoutIcon from '@mui/icons-material/Logout';

const PermissionDenied = () => {
  const theme = useTheme();

  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    try {
      await Auth.signOut();
    } catch (error) {
      console.error('Error signing out: ', error);
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: theme.palette.mode === 'dark' ? '#121212' : '#f5f5f5',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <ErrorOutlineIcon
        sx={{
          fontSize: 80,
          color: theme.palette.error.main,
          mb: 2,
        }}
      />
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          color: theme.palette.text.primary,
          mb: 1,
        }}
      >
        Permission Denied
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          mb: 3,
        }}
      >
        Sorry, you don’t have the necessary permissions to access this page.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleLogout}
        startIcon={
          loading ? <CircularProgress size={21} sx={{ color: 'white' }} /> : <LogoutIcon />
        }
        disabled={loading}
      >
        Logout
      </Button>
    </Box>
  );
};

export default PermissionDenied;
